import React, { useEffect, useState } from "react";
import { Container, Table } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { IoEye } from "react-icons/io5";
import BackIcon from "../../../../assets/svg/BackIcon";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Footer from "../../../../containers/Footer";
import { API_URLS } from "../../../../config/apiUrls";
import { useSWRFetcher } from "../../../../hooks/useSWRHooks";
import moment from "moment/moment";
import LeftArrow from "../../../../assets/images/icons/back.png";
import usePaginationHook from "../../../../hooks/usePaginationHook";
import { QueryStringfy } from "../../../../utils/qs.utils";
import PaginationCard from "../../../components/PaginationCard";

const Bonus = () => {
  const navigate = useNavigate();
  const pagination = usePaginationHook({});
  const [paginatedData, setPaginatedData] = useState([]);
  console.log("paginatedData", paginatedData);
  const queryString = QueryStringfy({
    ...pagination?.apiParams,
  });
  const { data } = useSWRFetcher({
    url: `${API_URLS.BONUS.CLAIMS}?${queryString}`,
    isExternalFetch: true,
  });

  useEffect(() => {
    if (data?.statement) {
      setPaginatedData(data);
    }
  }, [data, pagination.apiParams]);
  return (
    <>
      <HeaderAfterLogin />

      <main className="main mt-4">
        <div className="container">
          <Container>
            <div className="headingSec">
              <div className="back-link" onClick={() => navigate(-1)}>
                <img src={LeftArrow} alt="LeftArrow" /> <h1>Bonus</h1>
              </div>
            </div>

            <div className="my-4">
              <div className="table-responsive new_table">
                <Table className="table bonus_table">
                  <thead className="">
                    {/* <th width="">Name</th> */}
                    <th width="">Code</th>
                    <th>Bonus Type</th>
                    <th width="">Bonus Amount</th>
                    <th width="">Rollover amount </th>
                    {/* <th>Parts</th> */}
                    <th width="">Created date</th>
                    <th width="">View </th>
                  </thead>
                  <tbody>
                    {Array.isArray(paginatedData?.statement) &&
                      paginatedData?.statement.map((item, index) => (
                        <tr key={index}>
                          {/* <td>{item.bonusName}</td> */}
                          <td>{item.bonusCode}</td>
                          <td>{item.bonusType}</td>
                          <td>
                            {item.creditedAmount} / {item.creditableAmount}
                          </td>
                          <td>
                            {item.claimedAmount} / {item.goalAmount}
                          </td>
                          {/* <td>
                          {item.claimedParts} / {item.totalParts}
                        </td> */}
                          <td>
                            {" "}
                            {moment(item.createdAt).format("DD-MM-YY h:mm")}
                          </td>

                          <td>
                            {" "}
                            <Link to={`/bonus/${item.id}`}>
                              <IoEye className="eye_" />
                            </Link>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
                <div className=" border-t px-3 pb-5">
                  <PaginationCard pagination={pagination} count={data?.count} />
                </div>
              </div>
            </div>
          </Container>
        </div>
        <Footer />
      </main>
    </>
  );
};

export default Bonus;
